import _ from 'lodash';
import { Logger } from '@/helpers/log';
import { fromLegacy as fromLegacyWidget, toLegacy as toLegacyWidget } from './widgets';

const logger = new Logger('legacy:migration:dashboards');

export function fromLegacy(dashboard) {
  const reference = _.cloneDeep(dashboard);
  const source = _.cloneDeep(dashboard);
  const widgets = Object.values(source.widgets || {}).map((widget) => {
    const {
      id,
      position: { 0: top, 1: left },
      size: { x: width, y: height },
    } = widget;
    // current widget id allocation does no ensure no collisions:
    const wid = `${source.id}/${id}`;
    const pointer = {
      id: wid, top, left, width, height,
    };
    const { resources, widget: spec } = fromLegacyWidget(widget);
    spec.id = wid;
    // widgets are not separate endpoint, save ref:
    spec.dashboard = source.id;
    return { resources, pointer, spec };
  });
  const resources = widgets.reduce((
    { filters, properties, kpis },
    { resources: { filters: fs, properties: ps, kpis: ks } },
  ) => ({
    filters: fs.reduce((r, f) => ({ ...r, [f.$id]: f }), filters),
    properties: ps.reduce((r, p) => ({ ...r, [p.name]: p }), properties),
    kpis: ks.reduce((r, k) => ({ ...r, [k.$id]: k }), kpis),
  }), { filters: {}, properties: {}, kpis: {} });
  const transformed = {
    id: source.id,
    name: source.name,
    widgets: widgets.map(({ pointer }) => pointer),
  };
  const { sliceProperty, filter } = source;
  if (sliceProperty) {
    transformed.sliceProperty = sliceProperty;
  }
  if (filter) {
    transformed.filter = filter;
  }
  return {
    reference,
    resources: { id: source.id, ...resources },
    widgets: widgets.map(({ spec }) => spec),
    dashboard: transformed,
  };
}

export function toLegacy(dashboard, widgets = []) {
  const {
    id,
    name,
    sliceProperty,
    filter,
    widgets: pointers = [],
  } = dashboard;
  const linked = pointers.map((p) => {
    const {
      id: pid, top, left, width, height,
    } = p;
    const position = { 0: top, 1: left };
    const size = { x: width, y: height };
    const widget = widgets.find(({ id: wid }) => wid === pid);
    if (!widget) {
      logger.warn('Dashboard points to missing widget', pid);
      return null;
    }
    // no need to re-link widgets, as unlinking is desired state.
    const { id: wid, type, settings } = toLegacyWidget(widget);
    delete settings.dashboard;
    const legacyId = Number.parseInt(wid.replace(`${id}/`, ''), 10);
    return {
      id: legacyId, position, size, type, settings,
    };
  });

  const legacyObj = {
    id,
    name,
    widgets: linked.length ? linked.reduce((s, w) => ({ ...s, [w.id]: w }), {}) : undefined,
  };

  if (sliceProperty) {
    legacyObj.sliceProperty = sliceProperty;
  }
  if (filter) {
    legacyObj.filter = typeof filter === 'string' ? filter : filter.id;
  }

  return legacyObj;
}
